// extracted by mini-css-extract-plugin
export default {"spinnerBox":"Spinner_spinnerBox__so7uF"};